import * as React from "react"
import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"
import './footer.scss'

const Footer = ({ siteTitle }) => (
  <div className='footer'>
    <div className='logo'>
      <StaticImage
        src="../images/ft_logo_white.png"
        width={152}
        quality={95}
        formats={["auto", "webp", "avif"]}
        alt="Fantuan Delivery"
      />
    </div>
    <div className="company-name">Copyright © 2022 Fantuan</div>
    <div className="social">
      <a href="https://www.facebook.com/Van-Fantuan-582755635428346/?eid=ARBjICJYGD2h7qQ0JDddDn4-C-OovGA7gvTch8cfn8_xpsB7eTtm3zt-UrEEqo9BuNWfizjyOrprYDw-" className="fb">Facebook</a>
      <a href="https://www.youtube.com/channel/UCz8NWT_9fiQ1Q9fweNnPESw" className="yt">YouToBe</a>
      <a href="https://www.linkedin.com/company/17924108" className="li">LinkedIn</a>
      <a href="https://instagram.com/fantuanofficial?igshid=9d7nbxt2tx7z" className="is">instagram</a>
    </div>
  </div>
)

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
